/**
 * This file loads all the Vue components located in the components directory.
 * The components are named after their file path, for example:
 * A component located in components/passport/AuthorizedClients.vue will be named:
 * passport-authorized-clients
 */

/**
 * Loads all Vue components, given a certain context. All available file paths are transformed to
 * component names and are subsequently loaded as a Vue component.
 *
 * @param {object} context The context created by require.context()
 * @returns {void}
 */
const initializeComponents = {
	install:
		(app) => {
			const context = require.context('./components/', true, /\.vue$/);

			context.keys().forEach((key) => { // key might be './abc/def.vue'
				const fileString = key
					.split('/') // Split by directories: [ '.', 'abc', 'def.vue' ]
					.pop() // Pop first value: Filename without directories: def.vue
					.replace(/\.\w+$/, ''); // Remove file extension: def

				app.component(fileString, context(key).default);
			});
		}
};

export default initializeComponents;
